import React from 'react'

export interface IIconPlus {}

export default function IconPlus() {
  return (
    <svg
      width="100%"
      height="100%"
      preserveAspectRatio="none"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className=""
        d="M10 10H5M10 5V10V5ZM10 10V15V10ZM10 10H15H10Z"
        stroke="inherit"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  )
}
